module.exports = __webpack_public_path__ + "static/media/favicon-picox707.90176b0c.ico";